import type { OnlinePaymentMethods } from '@tebuto/widget/booking/types'

export type WidgetOnlinePaymentMethod = OnlinePaymentMethods[number]

export function mapTebutoMethodToStripePaymentMethodType(method: WidgetOnlinePaymentMethod): string | null {
    switch (method) {
        case 'card':
        case 'apple_pay':
        case 'google_pay':
            return 'card'
        case 'klarna':
            return 'klarna'
        case 'sepa':
            return 'sepa_debit'
        case 'bank_transfer':
            return 'customer_balance'
        default:
            return null
    }
}
